import { IonButton, useIonAlert } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { assignLocations } from "../../../store/formsubmitted/actions/assignLocations";
import { selectLocationsSelectedCounter } from "../../../store/formsubmitted/selectors/selectLocationsSelectedCounter";

export const ConfirmButton = () => {
  const dispatch = useDispatch();
  const [present] = useIonAlert();
  const selectedLocationsCounter = useSelector(selectLocationsSelectedCounter);

  const onSubmit = async () => {
    dispatch(assignLocations());
  };

  return (
    <>
      <IonButton
        fill="solid"
        size="large"
        color="secondary"
        onClick={() => {
          present({
            header: `¿Deseas asignar ${selectedLocationsCounter} ${
              selectedLocationsCounter === 1 ? "instalación" : "instalaciones"
            }?`,
            buttons: [
              "No",
              {
                text: `Asignar ${selectedLocationsCounter} ${
                    selectedLocationsCounter === 1 ? "instalación" : "instalaciones"
                }`,
                handler: () => onSubmit(),
              },
            ],
          });
        }}
      >
        Guardar
      </IonButton>
    </>
  );
};
